import { useState } from 'react'

interface PriceInputProps {
  value: number
  onChange: (value: number) => void
  onError?: (error: string | null) => void
  className?: string
  label?: string
  placeholder?: string
  disabled?: boolean
  showApiPriceHint?: boolean
  apiPrice?: number | null
  helperText?: string
}

export function PriceInput({
  value,
  onChange,
  onError,
  className = '',
  label,
  placeholder = '0.00',
  disabled = false,
  showApiPriceHint = false,
  apiPrice = null,
  helperText,
}: PriceInputProps) {
  const [error, setError] = useState<string | null>(null)

  const handleChange = (inputValue: string) => {
    // Clear error when user starts typing
    if (error) {
      setError(null)
      onError?.(null)
    }

    // Allow empty string, numbers, and one decimal point
    if (inputValue === '' || /^\d*\.?\d*$/.test(inputValue)) {
      onChange(parseFloat(inputValue))
    }
  }

  const hasApiPrice = apiPrice != null
  const displayPlaceholder = hasApiPrice && !value ? apiPrice.toFixed(2) : placeholder

  return (
    <div className={className}>
      {label && (
        <label className="block font-medium mb-2 text-sm">
          {label}
          {showApiPriceHint && hasApiPrice && <span className="text-xs ml-2">(API: ${apiPrice.toFixed(2)})</span>}
        </label>
      )}
      <div className="relative">
        <span className="absolute left-4 top-1/2 -translate-y-1/2 text-base">$</span>
        <input
          type="number"
          value={value}
          onChange={(e) => handleChange(e.target.value)}
          placeholder={displayPlaceholder}
          disabled={disabled}
          inputMode="decimal"
          className="w-full py-3 pl-8 pr-4 bg-white/20 border border-gray-300 rounded-lg text-base placeholder:text-white/50 focus:outline-none focus:ring-2 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
        />
      </div>
      {error && <p className="mt-2 text-red-300 text-sm m-0">{error}</p>}
      {helperText && !error && <p className="mt-2 text-white/70 text-xs m-0">{helperText}</p>}
    </div>
  )
}
